import React, { Dispatch, SetStateAction } from "react";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import article1Thumbnail from '../image/articles/essay26021.webp';
import ProtectedPage from "../components/ProtectedPage";
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import image1 from "../image/articles/essay20260301.webp";
import image2 from "../image/articles/essay20260302.webp";
import image3 from "../image/articles/essay20260303.webp";
import image4 from "../image/articles/essay20260304.webp";
import image5 from "../image/articles/essay20260305.webp";
import image6 from "../image/articles/essay20260306.webp";
import image7 from "../image/articles/essay20260307.webp";
import image8 from "../image/articles/essay20260308.webp";
import { Divider } from "@mui/material";
import { Wavedivider } from "../components/Wavedivider";
import { QuoteBlock } from "../components/QuoteBlock";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';
import { ProtectedArticleGroup } from "../articleDetailPage/ProtectedArticleGroup";

function Essay2603(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
      
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2603_PASSWORDS
      );
      const sectionLockHashes = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2603_SECTION_PASSWORDS
      );
      const images1 = [image1];
      const images2 = [image2];
      const images3 = [image3];
      const images4 = [image4, image5, image6];
      const images5 = [image7, image8];

      useMetaTags({
        title: '26.03. 회고 - Lynkim',
        description: '상실 / 이직 / 피겨스케이팅 / 보드게임 제작',
        image: '/ogimage.png',
      });
      
      return (
        <>
        <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요">
          <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
          <div className='fadeIn '>
            <ArticleTitle
              title={'26.03. 회고'}
              titleEn={'26.03. Review'}
              description={<div>상실 / 이직 / 피겨스케이팅 / 보드게임 제작</div>}
              descriptionEn={<div>Loss / Changing jobs / Figure skating / Making a board game</div>}
              category={'essay'}
              date={'2026.03.22.'}
              thumbnail={image1}
              />
          </div>
          <Wavedivider/>
          <div className='articleLayout'>
            <ArticleTextSection
                title = '짧은 생각들'
                subTitle = 'Snippets'
                swapByLanguage={true}
                marginBottom={true}
                description= {
                  <div>
                    <b>(1)</b> 가끔 사람들은 다른 사람들의 호의와 베풂을 받기만 하고 감사함을 표현하지 않는다. 베푸는 것에 감사하지도 않고, 그저 자신이 이득을 보지 못할까 봐 걱정하고 불평한다. 그 모습이 너무 이기적으로 느껴져서 화가 났다. 그런데 그런 생각을 누군가 가만히 듣고는 꼬박 사람들에게 찾아가 감사함을 표현하더라. 스스로 더 나은 사람이 되려 바로 행동하는 모습을 보이는 그 사람이 너무 예쁘고 멋있었다.

                      <br/><br/>

                      <b>(2)</b> 4년 반 회사를 다니는 내내, 빠짐없이 나를 보면 웃으며 반갑게 고개 숙여 인사를 해 주던 사람이 있었다. 반갑게 인사하는 게 사소한 것처럼 보이지만, 자주 보는 사람에게 스스럼없이 매번 인사하는 사람은 거의 없다. 얼마 전에 그분이 내게, 유일하게 항상 인사를 잘 받아줘서 너무 고마웠다는 말을 전해 주셨다. <br/>

                      기억해 보면 나는 어릴 적 항상 누군가를 마주치면 웃는 버릇이 있었는데, 그 모습을 누군가는 안 좋은 의도로 받아들이는 것을 알고 나서 쉽게 웃지 않는 사람이 되었었다. 그런데 사람들에게 아무런 바람 없이, 그것도 회사에서, 항상 만나면 반갑게 웃어 주는 사람을 만나게 되어 나도 다시 마냥 웃으며 인사할 수 있었고, 그것만으로도 나는 너무 감사했다. <br/>

                      그런 감사함을 전했을 때 그분이 큰 감동을 느꼈다고 해 주셨는데, 오히려 나에게 밝은 면을 다시 만들어 주신 그분에게 내가 더 큰 감사함을 느낀다.

                      <br/><br/>

                      <b>(3)</b> 어느 주말 동안 극심한 스트레스와 슬픔으로 인해 해가 저물어 가는 시간까지도 내내 일어나지 못하고 있었다. 마음이 아파서 온몸에 식은땀이 나고, 일어나면 곧장 쓰러지고 말 것 같다는 느낌을 받았다. 그러던 중 우연찮게 갑자기 어느 분께서 오랜만에 안부 메시지를 보내왔는데, <br/>

                      <b>“날씨가 너무 좋아서 밖에 돌아다니면 기분이 상쾌해져요”</b>라는 메시지였다. 우연이었지만 그때에는 그 메시지 하나가 구덩이에 빠져 헤어나오지 못했던 나에게 유일한 동아줄이 되어, 온 힘을 다해 잡고 기어나올 수 있는 힘이 되어 주었다. 그날 한 발자국도 못 걸을 것 같았는데 조금씩 걸었고, 뛸 수도 있었다. <br/>

                      그분이 이 글을 읽고 자신도 모르는 새에 누군가에게 구원의 손길을 내밀어 주셨다는 것을 알아 주셨으면 좋겠다. 나를 꺼내 주셔서 너무 감사하다.

                      <br/><br/>

                      <b>(4)</b> TCI 기질 검사를 했다. 이미 너무 알고 있는 나의 모습이여서 새롭게 알게 된 건 크게 없었다. 하지만 이렇게 나에 대해 기준에 따라 정리된 지표로 알게되는 것은 항상 재미있다.

                      <br/><br/>

                      <b>(5)</b> 겨울 삿포로를 여행했다. 정말 추웠다. 사람이 너무 많아서 제대로 많은 것을 즐기지 못한 것 같아 아쉽다. 하지만 온전히 3일 내내 즐기고 놀기만 하는 시간은 큰 재미를 준다. 함께 간 사람도 나만큼 안정과 재미를 느꼈을까.
                  </div>}
                subDescription={
                  <div>
                    <b>(1)</b> Sometimes people just receive others' kindness and generosity without expressing gratitude. They don't appreciate what's given; they only worry and complain about not gaining enough for themselves. That selfishness made me angry. But someone quietly listened to me say this and then went around to each person to thank them. The way they immediately acted on becoming a better version of themselves was so lovely and impressive.

                      <br/><br/>

                      <b>(2)</b> Throughout the four and a half years I worked at the company, there was someone who, without fail, would smile and politely bow whenever they saw me. Greeting warmly might seem like a small thing, but very few people greet someone they see often each and every time without hesitation. Recently they told me they were grateful that I was the only one who always returned the greeting. <br/>

                      Looking back, I used to have a habit of smiling whenever I met someone as a child, but after learning that some people took that as having ill intent, I became someone who didn't smile easily. Then I met someone who, with no expectations, even at work, always greeted me with a warm smile—and that allowed me to smile back unguardedly again. Just that alone, I was so grateful for. <br/>

                      When I conveyed that gratitude, they said they were deeply moved—but really, I'm even more grateful to them for bringing my bright side back to life.

                      <br/><br/>

                      <b>(3)</b> One weekend, the extreme stress and sadness kept me from getting out of bed all the way until sunset. My heart hurt, my body broke out in cold sweats, and I felt like if I stood up I would collapse on the spot. Just then, out of nowhere, someone sent me a check-in message after a long time, <br/>

                      <b>"The weather's so nice—walking around outside feels so refreshing."</b> It was coincidence, but in that moment, that single message became the only rope for me, sunk deep in a pit and unable to climb out, and gave me the strength to grip it with everything I had and pull myself out. That day I thought I couldn't take a single step, but I walked little by little, and was even able to run. <br/>

                      I hope they read this and realize that, without even knowing it, they extended a hand of salvation. I'm so grateful they pulled me out.

                      <br/><br/>

                      <b>(4)</b> I took the TCI temperament test. It was a version of me I already knew so well that there wasn't much that was new. But it's always fun to see myself laid out as organized indicators against a framework.

                      <br/><br/>

                      <b>(5)</b> I traveled to Sapporo in winter. It was really cold. There were so many people that I feel like I couldn't fully enjoy as much as I'd hoped. But three solid days of doing nothing but enjoying and playing is a great kind of fun. I wonder if the person I went with felt the same kind of comfort and joy I did.
                  </div>}
                    />       
                <ArticleImageLayout images={images4} />
                <ProtectedArticleGroup
                lockPassword={sectionLockHashes}
                description="무엇에 대한 내용일까요?"
            >
         <ArticleTextSection
                title = '상실'
                subTitle = 'Loss'
                swapByLanguage={true}
                marginBottom={true}
                description= {
                  <div>
                    상실을 마주하면 그것이 나를 무너뜨리고 다시는 일어서지 못하게 만들어버릴 것만 같았는데, 막상 상실을 겪으니 그 구멍에 새로운 것들이 조금씩 스멀스멀 차오르고 있다. 꽉꽉 눌러 차있다보니 내가 뭘 받았고, 가지고 있었는지도 제대로 몰랐는데, 하나하나 빼내고 내려놓으면서 무엇이 원래 가지고 있던 것이고 무엇을 받아왔던 것인지 온전히 하나씩 느끼고 있다. <br/>

                    채워져있던 것들을 뜯어내어 보면서 그 안에 나는 원래 어떤 사람이었던가에 대해서 더듬어 보고 있다. 내가 좋아하는 것, 내가 가치있게 느끼는 것, 내가 가졌던 기준들, 내가 좋아하는 삶, 내가 싫어하는 것, 나도 모르고 있던 나의 모습, 성격, 장점, 단점들. <br/>
                    내가 얼마나 사람들에게 애정과 관심 그리고 온 마음을 쏟고 있었는지, 그리고 얼마나 쉽게 판단하고 무심했는지.
                    세상을 얼마나 다채롭고 온전히 만끽하며 관대하고 소중히 여기고 있었는지, 그리고 어떤 것엔 쉽게 외면하며 얼버무리며 불안함만 남겼는지.
                    세상을 얼마나 예민하게 잘 느끼고 싶어했고, 또 얼마나 무심하게 지나쳤는지. <br/><br/>
                    작년 7월부터 꾸준히 쓰던 회고글을 다시 다 되돌아 읽어보았다. 글이 나에게, <br/>

                    <b>"계속 넘어져도 괜찮아. 다시 일어나지더라. 그러니 다시 평안함이 찾아올 것이라는 걸 기억해." </b>  <br/>

                    라고 나에게 계속 말을 해줬다. 내가 다시 일어설 수 있게 힘을 주고 있는건 다름 아닌 나였다. 좋은 생각, 좋은 말들을 계속 적어준 나에게 고맙다. <br/> <br/>
                    사라지는 것들이 나의 완전한 실수와 잘못으로 잃어버린 것이라고 하더라도, 미련을 갖고 붙잡고 있을 필요는 없다. 떠나가는 것을 붙잡고 있느라 더 많은 것을 놓치지 말자. 놓쳐버린 수많은 것들을 잘 보내주고 나아가자. 오히려 온전히 다시 돌아볼 수 있는 기회가 주어진건 큰 선물이다. <br/>

                    그저 나에게 불편함을 피하지 않고 마주하는 법을 알려준 사람에게 온 마음을 다해 감사하다.
                  </div>
                }
                subDescription={
                  <div>
                    I always thought that facing loss would break me and leave me unable to stand again, but actually living through loss, new things are slowly creeping in to fill the hole. Things had been packed in so tightly that I hadn't really known what I'd been given or what I had, but by pulling each one out and setting it down, I'm coming to feel one by one what was originally mine and what had been given to me. <br/>

                    As I unpack what was filling me, I'm tracing back what kind of person I originally was. The things I like, the things I find valuable, the standards I held, the kind of life I love, the things I dislike, the parts of myself I didn't know about, my personality, strengths, weaknesses. <br/>
                    How deeply I poured affection, attention, and my whole heart into people, and how easily I also judged and stayed indifferent.
                    How richly and fully I savored the world with generosity and care, and how easily I also looked away from certain things, fudged them, and left only anxiety behind.
                    How sensitively I wanted to feel the world, and how unfeelingly I let so much pass by. <br/><br/>
                    I went back and reread all the retrospectives I've been writing since last July. The writing kept telling me, <br/>

                    <b>"It's okay to keep falling. You do get back up. So remember: peace will come again." </b>  <br/>

                    The one giving me the strength to stand back up was no one but me. Thank you, to the me who kept writing those good thoughts and good words. <br/> <br/>
                    Even if the things vanishing were lost through my own full faults and mistakes, I don't have to hold on to them out of regret. Don't let what's leaving make me miss even more by clinging. Send off the many things I've already lost, and move forward. The fact that I've been given the chance to look back fully is actually a great gift. <br/>

                    With all my heart, I'm grateful to the person who taught me how to face discomfort instead of avoiding it.
                  </div>
                }
                />
                </ProtectedArticleGroup>
          <ArticleTextSection
                title = '이직'
                subTitle = 'Changing Jobs'
                swapByLanguage={true}
                marginBottom={true}
                description= {
                  <div>
                    먼저 정말 많은 분들이 도움을 주셔서 정말 큰 감사하다. 나의 이직을 위해 회사에 대해 소개해 주고 티타임을 연결해 주셨던 분들, 나를 회사에 추천해 주고 자세히 컬처핏에 대해서도 조언해 주신 분, 나의 선택을 지지해 주었던 지금의 팀원들, 나를 좋게 포장해서 레퍼런스 체크를 도와준 분들, 모든 과정에 대해 응원해 주셨던 분들. 이번 달은 주변에서 많은 감사함을 얻고, 고마움은 아무리 표현해도 아깝지 않구나 하는 것들을 느끼게 되었다.<br/>

                    이직으로 인해 몸과 마음도 지쳤다. 다른 사람들도 이직 과정에서 느꼈을 고통에 제대로 공감하지 못했던 나의 어리석음도 느꼈다. <br/>

                    세상을 하나씩 경험하며 더듬어 가는 느낌이다. 이직은 생각보다 큰 이별이고, 행복했던 만큼 놓아줘야 하는 것도 너무 많다. 그래도 언젠가 많은 경험을 하고나서 다시 분명 돌아올 수도 있다. 아주 잠깐 다른 곳에 가는 것이라고 생각하니 아쉬움이 덜하다. 여기서 만난 인연들이 나에게 너무 소중하다. 오래도록 함께 살아가고 싶어, 이 관계를 유지하기 위해 더 노력할 거다.
                  </div>
                }
                subDescription={
                  <div>
                    First of all, so many people helped me, and I'm deeply grateful. The people who introduced me to companies and set up tea times for me, the person who recommended me and gave detailed advice on culture fit, my current teammates who supported my choice, the people who helped with reference checks by speaking well of me, and everyone who cheered on the whole process. This month, I received so much from the people around me, and I came to feel that you can never overdo expressing gratitude.<br/>

                    The job change wore me out, both in body and in mind. I also felt how foolish I'd been in not properly empathizing with the pain other people must have felt going through their own job changes. <br/>

                    It feels like I'm experiencing the world one thing at a time, feeling my way through it. A job change is a bigger goodbye than I expected, and there's so much to let go of in proportion to how happy I was. Still, after gaining a lot of experiences elsewhere, I might definitely come back someday. Thinking of it as just briefly going somewhere else makes the sadness less. The connections I made here are so precious to me. Because I want to share life with them for a long time, I'll put even more effort into keeping these relationships.
                  </div>
                }
                />
           <ArticleImageLayout images={images2} />
          <ArticleTextSection
                title = '피겨스케이팅'
                subTitle = 'Figure Skating'
                swapByLanguage={true}
                marginBottom={true}
                description= {
                  <div>
                    거의 15년 만에 스케이트를 다시 타기 시작했다. 스케이트는 내가 너무 좋아하는 스포츠였다. 스케이트를 그만둔 건 나의 의지가 아닌 부모님의 의지였기 때문에 그 상실감이 커서, 지금까지 스케이트장 가까이도 가지 못했었다. 스케이트장 가까이 가면 다시는 하지 못한다는 슬픔이 몰려올까 봐 피해 왔었다. 오랜 시간이 지나서 다 회복하고 그저 즐길 수 있게 되기까지 꽤나 시간이 걸렸던 것 같다. <br/>

부모님이 내가 왜 좋아하는 스케이트를 다시 타지 못하게 했는지에 대해 당시에는 내가 너무 안 좋은 친구들과 어울리는 것 같아서 못하게 했다고 하셨는데, 조금 지나 알고 보니 돈을 지원하기 어려워서 못 하게 했던 것이었다고 한다. 그냥 사실대로 말해 주셨다면 더 오래 상처를 안고 있지 않고 이해했을 것 같았는데, 잃어버린 것이 내 잘못으로 인한 것이라고 생각해서 자책하고 회복까지 더 많은 시간이 필요했던 것 같아 아쉽다.<br/>

하지만 지금은 그저 가끔씩 차가운 바람 쐬며 자유롭게 스케이트를 타는 게 그저 재미있기만 하다.
                  </div>
                }
                subDescription={
                  <div>
                    I started skating again after almost 15 years. Skating was a sport I loved deeply. Quitting wasn't my choice but my parents', and the sense of loss was so big that until now I couldn't even go near a rink. I avoided going close because I was afraid the sadness of not being able to skate anymore would come rushing back. After a long time, it took quite a while to recover enough to just enjoy it again. <br/>

At the time, my parents said they made me stop because they thought I was hanging out with bad friends, but a little later I found out the real reason was that they couldn't afford to support it financially. If they had just told me the truth, I think I would have understood instead of carrying the wound that long. Believing I had lost something because of my own fault made me blame myself, and I think it added a lot more time to the recovery, which is unfortunate.<br/>

But now, occasionally feeling the cold air and skating freely is just simply fun.
                  </div>
                }
                />
                    <ArticleImageLayout images={images3} />
          <ArticleTextSection
                title = '보드게임 제작'
                subTitle = 'Making a Board Game'
                swapByLanguage={true}
                marginBottom={true}
                description= {
                  <div>
                    1차, 2차, 3차, 4차, 5차 계속하여 보드게임을 테스트하고 있고 점점 더 좋은 컨셉, 더 좋은 룰로 업데이트를 해나가고 있다. 무언가 제대로 도전한다는 것은 그만큼 설렘도 있지만, 어려움과 지겨움을 버텨내야하는 것도 포함되어있다. 일과 병행하다보니 그만큼 어려움이 크다. 그 과정을 항상 묵묵히 함께 해주고, 더 노력해주시는 두 분께 항상 감사함을 느낀다. 꼭 좋은 결과물을 만들어내자.
                  </div>
                }
                subDescription={
                  <div>
                    First, second, third, fourth, fifth round—we keep testing the board game and updating it with better concepts and better rules. Taking on a real challenge brings excitement, but it also means enduring the difficulty and the tedium. Doing it alongside work makes the difficulty that much greater. I'm always grateful to the two people who quietly walk through this process with me and put in the extra effort. Let's definitely make something good come out of this.
                  </div>
                }
                />
                    <ArticleImageLayout images={images5} />
          <NextItem to='/Essay2602' thumbnail={article1Thumbnail} nextProjectTitle='26.02.회고'/>

          <BackButton/>
          </div>
          </ProtectedPage>
          </>
        
         
     )
  }
  
  export default Essay2603;
